export const DangerIcon = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg width={15} height={16} fill="none" {...props}>
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M7.5 6.125V9.25M7.5 13.882H3.713c-2.17 0-3.075-1.55-2.025-3.444l1.95-3.512 1.837-3.3c1.113-2.006 2.938-2.006 4.05 0l1.838 3.306 1.95 3.512c1.05 1.894.137 3.444-2.025 3.444H7.5v-.006ZM7.497 11.125h.005"
    />
  </svg>
);
